<script>
import {defineComponent} from 'vue'
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import moment from "moment";
import BreadCrumbDynamic from "@/components/BreadCrumbDynamic.vue";
import {API_BASE, API_BASE_CATEGORIES, STATUS_OPTIONS} from "./constants";

export default defineComponent({
  name: "OpennessOrganizationsList",
  components: {BreadCrumbDynamic},
  computed: {
    moment() {
      return moment
    },
    brItems() {
      return this.$store.state.brItems
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      parent_id: null,
      page: 1,
      totalCount: 0,
      limit: 10,
      status: null,
      search: null,
      category_id: null,
      statusOptions: STATUS_OPTIONS,
      categoryOptions: [],
    }
  },
  methods: {
    onClickBrItem(id, index) {
      this.parent_id = id;
      this.$store.commit('sliceBrItems', index);
      this.getOrganizations()
    },
    indexMethod(index) {
      return index + (this.page - 1) * this.limit + 1
    },
    handleCurrentChange() {
      this.getOrganizations();
    },
    handleSizeChange() {
      this.page = 1;
      this.getOrganizations();
    },
    onFilterChange() {
      this.page = 1;
      this.getOrganizations();
    },
    onClickDelete(id) {
      ElMessageBox.confirm(
          'Ma\'lumoitni o\'chirasizmi?',
          'Diqqat!',
          {
            confirmButtonText: 'Ha',
            cancelButtonText: 'Bekor qilish',
            type: 'warning',
          }
      )
          .then(() => {
            this.loading = true
            this.$http.delete(`${API_BASE}/${id}`).then(() => {
              ElMessage({
                type: 'success',
                message: 'Muvaffaqqiyatli o\'chirildi',
              })
              this.getOrganizations();
            }).catch(({response}) => {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: response?.data?.message || 'Iltimos, qayta urinib ko\'ring',
              })
            }).finally(() => {
              this.loading = false
            })

          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: 'O\'chirish bekor qilindi',
            })
          })
    },
    onClickRow(row) {
      this.parent_id = row['id'];
      this.$store.commit('updateBrItems', {
        id: row['id'],
        title: row['title']
      })
      this.getOrganizations()
    },
    getCategoryOptions() {
      this.$http.get(API_BASE_CATEGORIES, {params: {limit: 100}}).then(({data}) => {
        this.categoryOptions = data.data;
      });
    },
    getOrganizations() {
      this.loading = true;
      this.$http.get(API_BASE, {
        params: {
          parent_id: this.brItems[this.brItems.length - 1]?.id,
          status: this.status,
          category_id: this.category_id,
          search: this.search,
          limit: this.limit,
          offset: this.limit * (this.page - 1)
        }
      }).then(({data}) => {
        this.tableData = data.data;
        this.totalCount = data.count;
      }).catch(({response}) => {
        ElNotification.error({message: response?.data?.message || "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },
  },
  mounted() {
    this.getCategoryOptions()
    this.$store.commit('clearBrItems')
    this.$store.commit('updateBrItems', {
      title: 'Budjet jarayonining ochiqligi reytingi',
      id: null
    })
    this.getOrganizations()
  }
})
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div>
        <bread-crumb-dynamic :items="brItems" @onClickItem="onClickBrItem"/>
      </div>
      <div class="filters">
        <el-input v-model="search" placeholder="INN yoki nomi bo'yicha qidirish" clearable
                  style="width: 240px" @change="onFilterChange"/>
        <el-select v-model="status" placeholder="Holati" clearable style="width: 160px" @change="onFilterChange">
          <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
        </el-select>
        <el-select v-model="category_id" placeholder="Kategoriya" clearable style="width: 200px" @change="onFilterChange">
          <el-option v-for="opt in categoryOptions" :key="opt.id" :label="opt.title" :value="opt.id"/>
        </el-select>
        <el-button type="primary" @click="$router.push({name: 'OpennessOrganizationFormAdd',query:{parent: parent_id}})">
          Qo'shish
        </el-button>
      </div>
    </div>
    <el-table :data="tableData"
              class="table"
              border
              row-style="cursor:pointer"
              @rowClick="onClickRow"
              height="calc(100vh - 245px)">
      <el-table-column type="index" label="T/R" width="80" :index="indexMethod" align="center"/>
      <el-table-column prop="inn" label="INN" width="120" align="center"/>
      <el-table-column prop="title" label="Nomi" min-width="220"/>
      <el-table-column prop="order" label="Tartib raqami" width="120" align="center"/>
      <el-table-column prop="category" label="Kategoriya" min-width="160"/>
      <el-table-column label="Holati" width="120" align="center">
        <template #default="scope">
          <el-tag :type="scope.row.status === 'ACTIVE' ? 'success' : 'info'">
            {{ scope.row.status === 'ACTIVE' ? 'Faol' : 'Faol emas' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="Yaratilgan sana" min-width="120">
        <template v-slot="scope">
          {{ moment(scope.row.created_at).format("DD.MM.YYYY") }}
        </template>
      </el-table-column>
      <el-table-column label="" width="330" align="center">
        <template #default="scope">
          <el-button type="success" size="small"
                     @click.stop="$router.push({name: 'OpennessOrganizationFormAdd', query:{parent: scope.row.id}})">+
          </el-button>
          <el-button type="warning" size="small"
                     @click.stop="$router.push({name: 'OpennessOrganizationReports', params:{id: scope.row.id}})">
            Hisobotlar
          </el-button>
          <el-button type="primary" size="small"
                     @click.stop="$router.push({name: 'OpennessOrganizationFormEdit', params:{id: scope.row.id}})">
            Tahrirlash
          </el-button>
          <el-button type="danger" size="small"
                     @click.stop="onClickDelete(scope.row.id)">O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div>Umumiy soni: {{ totalCount }}</div>
      <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="totalCount"
          v-model:page-size="limit"
          v-model:current-page="page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.filters {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
